<script>
	import Footer from "./components/Footer.svelte";
	import Header from "./components/Header.svelte";
    import HorizontalLine from "./components/HorizontalLine.svelte";
    import Impressum from "./components/Impressum.svelte";
    import Innovationsvorhaben from "./components/Innovationsvorhaben.svelte";
    import Laborkonzepte from "./components/Laborkonzepte.svelte";
    import OnlineLabore from "./components/OnlineLabore.svelte";
    import Partnerlogos from "./components/Partnerlogos.svelte";
	import Projektbeschreibung from "./components/Projektbeschreibung.svelte";

	let openImpressum = false;
	function toggleImpressum() {
		openImpressum = !openImpressum;
	}
	$: impressumVisible = (openImpressum) ? '' : 'invisible';
</script>


<svelte:head>
	<title>OnLabEdu | Online-Labore für naturwissenschaftliche Aus- und Weiterbildung</title>
</svelte:head>


<Header />

<main>
	<Projektbeschreibung />
	<HorizontalLine />

	<OnlineLabore />
	<HorizontalLine />

	<Innovationsvorhaben />
	<HorizontalLine />

	<Laborkonzepte />
	<HorizontalLine />

	<Partnerlogos />
</main>

<Footer on:click={toggleImpressum} />

<Impressum on:click={toggleImpressum} bind:impressumVisible />


<style global lang="postcss">
	@tailwind base;
	@tailwind components;
	@tailwind utilities;

	@layer components {
		.bg-onlabedu-blue {
			--tw-bg-opacity: 1;
			background-color: rgb(28 173 229 / var(--tw-bg-opacity));
		}
		.bg-onlabedu-green {
			--tw-bg-opacity: 1;
			background-color: rgb(147 195 83 / var(--tw-bg-opacity));
		}
		.bg-onlabedu-red {
			--tw-bg-opacity: 1;
			background-color: rgb(234 81 84 / var(--tw-bg-opacity));
		}
	}

	main {
		text-align: center;
		padding: 1em;
		max-width: 240px;
		margin: 0 auto;
	}

	h1 {
		text-transform: uppercase;
		font-size: 3em;
		font-weight: 100;
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}
</style>
